<span class="ws-search-summary" *ngIf="mergedConfig.multiSelect && !inputFocused && selectionSummary">{{ selectionSummary }}</span>

<input *ngIf="!mergedConfig.multiSelect" (input)="onInput($event)" (keyup)="onKeyUp($event)" (focus)="onInputFocus()" (blur)="onInputBlur()" [matAutocomplete]="auto"
  #autoTrigger="matAutocompleteTrigger"
  [wsTooltip]="(mergedConfig.tooltip || '') | translate" class="ws-search-input mat-elevation-z4"
  [class.ws-search-toolbar]="mergedConfig.variant === 'toolbar'" [class.ws-search-expanded]="mergedConfig.expanded"
  matInput [placeholder]="(mergedConfig.placeholder || '') | translate" type="text" #searchBox
  [ngClass]="{ 'ws-search-hidden': !mergedConfig.expanded }" />

<input *ngIf="mergedConfig.multiSelect" (input)="onInput($event)" (keyup)="onKeyUp($event)" (focus)="onInputFocus()" (blur)="onInputBlur()"
  [wsTooltip]="(mergedConfig.tooltip || '') | translate" class="ws-search-input mat-elevation-z4"
  [class.ws-search-expanded]="mergedConfig.expanded" [class.summary-mode]="!inputFocused"
  matInput [placeholder]="inputFocused ? ((mergedConfig.placeholder || '') | translate) : ''" type="text" #searchBox
  [ngClass]="{ 'ws-search-hidden': !mergedConfig.expanded }" />

<ng-template #multiPanel>
  <div class="ws-multi-panel" (mousedown)="$event.preventDefault()">
    <button type="button" class="ws-multi-option" *ngFor="let result of searchResults"
      (mousedown)="$event.preventDefault()" (click)="pickOption(result.id)">
      <mat-checkbox class="ws-search-check" [checked]="isSelected(result)" [disableRipple]="true"></mat-checkbox>
      <ng-container *ngIf="resultTemplate; else defaultMultiLabel">
        <ng-container *ngTemplateOutlet="resultTemplate; context: { $implicit: result, displayData: result.displayData }"></ng-container>
      </ng-container>
      <ng-template #defaultMultiLabel>
        <span class="ws-multi-label">{{ optionLabel(result) }}</span>
      </ng-template>
    </button>
    <div class="ws-search-no-results" *ngIf="!searchResults.length">{{ 'No results found' | translate }}</div>
  </div>
</ng-template>

<mat-icon *ngIf="showClearIcon"
  class="ws-search-clear"
  [class.ws-search-toolbar]="mergedConfig.variant === 'toolbar'"
  (click)="clearAndCollapse($event)">
  close
</mat-icon>

<mat-icon *ngIf="mergedConfig.showIcon" [class.ws-search-toolbar]="mergedConfig.variant === 'toolbar'"
  (click)="toggleOpen()">
  search
</mat-icon>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onResultSelected($event)" class="ws-search-autocomplete">
  <!-- Only show content if search length meets minimum requirement -->
  <ng-container *ngIf="shouldShowAutocomplete || mergedConfig.multiSelect">
    <!-- Loading spinner while searching -->
    <mat-option *ngIf="loading && mergedConfig.showSpinner" disabled>
      <div style="display: flex; align-items: center; justify-content: center; padding: 8px;">
        <mat-spinner diameter="25"></mat-spinner>
        <span style="margin-left: 8px;">{{ 'Searching...' | translate }}</span>
      </div>
    </mat-option>

    <!-- Search results - only show when not loading -->
    <mat-option *ngFor="let result of searchResults" [value]="result.id" class="ws-search-result"
      [class.ws-search-multi]="mergedConfig.multiSelect"
      (mousedown)="mergedConfig.multiSelect && $event.preventDefault()"
      [style.display]="loading ? 'none' : 'block'">
      <!-- Custom template if provided -->
      <ng-container *ngIf="resultTemplate; else defaultTemplate">
        <ng-container
          *ngTemplateOutlet="resultTemplate; context: { $implicit: result, displayData: result.displayData }"></ng-container>
      </ng-container>

      <!-- Default template -->
      <ng-template #defaultTemplate>
        <div class="ws-search-result-content">
          <div *ngFor="let field of getDisplayFields(result)" [class]="field" class="ws-search-field">
            {{ result.displayData[field] }}
          </div>
        </div>
      </ng-template>
    </mat-option>

    <!-- No results message - only show when not loading and no results -->
    <mat-option *ngIf="mergedConfig.showNoResultsMessage && !loading && searchResults.length === 0 && searchBox?.value"
      disabled>
      <span class="ws-search-no-results">{{ 'No results found' | translate }}</span>
    </mat-option>
  </ng-container>
</mat-autocomplete>